import React, {memo} from "react";
import RegistrationForService from "../../../widgets/RegistrationForService";
import {getParamsFromUrl} from "../../../utils/url";


const RegistrationForServicePage = ({history}) => {
    const clientParams = getParamsFromUrl(history.location.search);

    return <RegistrationForService {...clientParams}/>
};

export default memo(RegistrationForServicePage);